import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_AUDIT_GROUPS_FOR_REPORTS = "GET_AUDIT_GROUPS_FOR_REPORTS";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Audit/getauditgroups/null`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_AUDIT_GROUPS_FOR_REPORTS, service, mock);
